import React, { useContext, useState, useEffect } from 'react'
import { Button, Table } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, TablePagination, Loading } from '../Library'
import { useHistory } from 'react-router-dom'
import "./Rental.css"
import dayjs from 'dayjs'
import { listAllRental, RentalStatus } from '../Network/Rental'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faQuestionCircle, faCheckCircle, faClock, faTimesCircle, faExclamationCircle, faBan } from '@fortawesome/free-solid-svg-icons'

function Rental() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.tenant
    const history = useHistory()
    const [listRental, setRental] = useState([])
    const [countRental, setCountRental] = useState(0)
    const [isLoading, setIsLoading] = useState(false)

    // Content list
    const [page, setPage] = useState(1);
    const size = 10

    useEffect(()=>{
        const fetchData = () => {
            setIsLoading(true)
            listAllRental(
                page,
                size,
                (data)=>{
                    setRental(data.data)
                    setCountRental(data.count)
                    setIsLoading(false)
                },
                (error)=>{
                    setIsLoading(false)
                }
            )
        }

        fetchData()
    },[page])

    return (
        <div id="tenant">
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.tenant_management}/>
            {/* <Button onClick={()=>history.push("/rental/add")}>
                {lang.add_tenant}
            </Button> */}

            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.tenant_area}</th>
                            <th>{lang.contract_no}</th>
                            <th>{lang.rental_start_date}</th>
                            <th>{lang.expired_lease}</th>
                            <th>{lang.status}</th>
                            <th>{lang.request_by}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { listRental.map((item, key) =>
                        <RentalItem
                        key={key}
                        location={item.location}
                        contractNo={item.contractNo}
                        startLeaseDate={item.startLeaseDate}
                        expireDate={item.expiredDate}
                        status={item.status}
                        requestBy={item.createLeaseBy}
                        onDetailClick={()=>history.push(`/rental/detail/${item.id}`)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
                dataLength={Math.ceil(countRental / size)}
                size={size}
                currentPage={page}
                handlerPaginationClick={(page)=>{ setPage(page) }}
                nextClick={()=>{ setPage(page + 1) }}
                prevClick={()=>{ setPage(page - 1) }}
                firstPageClick={(first)=>{ setPage(first) }}
                lastPageClick={(last)=>{ setPage(last) }}
                disabledPrev={page === 1}
                disabledNext={page === Math.ceil(countRental / size)}
                />
        </div>
    )
}

function RentalItem({ location, startLeaseDate, expireDate, requestBy, status, contractNo, onDetailClick, onDeleteClick }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.tenant
    let statusIcon = { icon: faQuestionCircle, color: 'grey', text: lang.no_status }

    switch(status){
        case(RentalStatus.ACTIVE):
            statusIcon = { icon: faCheckCircle, color: 'green', text: lang.active }
            break
        case(RentalStatus.IN_ACTIVE):
            statusIcon = { icon: faBan, color: 'grey', text: lang.in_active }
            break
        case(RentalStatus.WAITING):
            statusIcon = { icon: faClock, color: 'orange', text: lang.waiting }
            break
        case(RentalStatus.CANCELLED):
            statusIcon = { icon: faTimesCircle, color: 'red', text: lang.cancelled }
            break
        case(RentalStatus.OVERDUE):
            statusIcon = { icon: faExclamationCircle, color: 'red', text: lang.overdue }
            break
        case(RentalStatus.DISABLE):
            statusIcon = { icon: faBan, color: 'red', text: lang.disable }
            break
        case(RentalStatus.EXPIRED):
            statusIcon = { icon: faExclamationCircle, color: 'red', text: lang.expired }
            break
        case(RentalStatus.EXPIRE_SOON):
            statusIcon = { icon: faExclamationCircle, color: 'orange', text: lang.expire_soon }
            break
    }

    return(
        <tr >
            <td style={{textAlign: 'center', fontSize: 18}}>
                <FontAwesomeIcon icon={statusIcon.icon} color={statusIcon.color}/>
            </td>
            <td>{location}</td>
            <td>{contractNo}</td>
            <td>{dayjs(startLeaseDate).format("D MMMM YYYY")}</td>
            <td>{dayjs(expireDate).format("D MMMM YYYY")}</td>
            <td>{statusIcon.text}</td>
            <td>{requestBy}</td>
            <td style={{ width: 150 }}>
                <Button size="sm" style={{ marginRight: 10 }} onClick={onDetailClick}>
                    {lang.detail}
                </Button>
                {/* <Button variant="danger" size="sm">
                    <FontAwesomeIcon icon={faTrash}/>
                </Button> */}
            </td>
        </tr>
    )
}

export default Rental
